import { rem } from 'polished';
import styled from 'styled-components';

const HuePickerContainer = styled.div`
    box-shadow: ${({ theme }) => theme.base.boxShadow.elevationSmall};
    margin-bottom: ${rem(16)};
    margin-top: ${rem(8)};
    position: relative;
`;

export default HuePickerContainer;
